import SettingsStore from '../../settings/SettingsStore';

import syncSettingsWithEditor from '../../settings/syncSettingsWithEditor';
import syncDocumentHeightWithViewer from '../syncDocumentHeightWithViewer';
import syncDocumentWidthWithViewer from '../syncDocumentWidthWithViewer';
import syncSettingsAppWithWidgetPage from '../syncSettingsAppWithWidgetPage';
import syncRouterWithViewer from '../syncRouterWithViewer';

function initTPAViewModeEditor(tpaParams, settingsStore: SettingsStore) {
  syncRouterWithViewer();
  syncSettingsAppWithWidgetPage();
  syncSettingsWithEditor(settingsStore, tpaParams.deviceType);
  syncDocumentHeightWithViewer();
  syncDocumentWidthWithViewer(tpaParams.deviceType);
}

export default initTPAViewModeEditor;
